import React, { useEffect, useState } from 'react';
import { MdExitToApp, MdHome } from 'react-icons/md';
import { Link } from 'react-router-dom';

import { StatusEnum } from '../../utils/enumerators/Status.enum';
import { StorageEnum } from '../../utils/enumerators/Storage.enum';

import './PageDefault.scss';

export default function PageDefault({ children, status, showFooter }) {
	function logout() {
		localStorage.removeItem(StorageEnum.GITLAB_TOKEN);
		localStorage.removeItem(StorageEnum.GITLAB_REFRESHTOKEN);
		window.open(location.origin, '_self');
	}

	if (showFooter == null) {
		showFooter = true;
	}

	return (
		<div className="page-default">
			<main>{children}</main>

			{((showFooter && status == null) || status == StatusEnum.SUCCESS) && (
				<footer>
					<div className="container">
						{document.location.pathname != '/login' && document.location.pathname != '/' && (
							<>
								<Link
									to="/"
									title="Voltar para o início">
									{' '}
									<MdHome />{' '}
								</Link>
								<br />
								<br />
							</>
						)}

						{document.location.pathname == '/build-ios' && (
							<>
								Ir para o{' '}
								<a
									title="Ir para o Dashboard do Bitrise"
									target="_blank"
									href={`https://app.bitrise.io/app/${window.RUNTIME_CONFIG.REACT_APP_APP_ID}#/builds`}>
									Dashboard Bitrise
								</a>
								<br />
								<br />
							</>
						)}
						{document.location.pathname == '/dashboard-android' && (
							<>
								<Link
									to="/build-android"
									title="Gerar Build Android">
									Gerar Build Android
								</Link>
								<br />
								<br />
							</>
						)}
						{document.location.pathname == '/build-android' && (
							<>
								<Link
									to="/dashboard-android"
									title="Ir para o Dashboard Android">
									Ir para o Dashboard Android
								</Link>
								<br />
								<br />
							</>
						)}

						{document.location.pathname == '/status' && (
							<>
								<Link
									to="/s1-mobile/status"
									title="Ir para os status do S1 Mobile">
									Ir para Status S1 Mobile
								</Link>
								<br />
								<br />
							</>
						)}

						{document.location.pathname == '/s1-mobile/status' && (
							<>
								<Link
									to="/status"
									title="Ir para os status B2C">
									Ir para Status B2C
								</Link>
								<br />
								<br />
							</>
						)}

						{document.location.pathname == '/' && status == StatusEnum.SUCCESS && (
							<>
								<div
									onClick={logout}
									className="logout"
									title="Sair da conta Gitlab">
									<span>Sair da conta</span>
									<MdExitToApp />
								</div>
								<br />
							</>
						)}
					</div>
				</footer>
			)}
		</div>
	);
}
